import Lottie from 'lottie-react';
import GDSLoader from '@/config/provider-portal-loader.json';
import './loader.css';
import { cn } from '@/libs';

type LoaderProps = {
  hasBackground?: boolean;
};

export const Loader: React.FC<LoaderProps> = ({ hasBackground = true }) => {
  const containerClasses = cn('loader-ui__container', {
    'loader-ui__container--transparent': !hasBackground,
  });

  return (
    <div className={containerClasses}>
      <Lottie className="loader-ui__loader" animationData={GDSLoader} />
    </div>
  );
};
